'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nameMaxLength = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _uniq2 = require('lodash/uniq');

var _uniq3 = _interopRequireDefault(_uniq2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.processMyPlaylist = processMyPlaylist;
exports.processMyPlaylists = processMyPlaylists;
exports.processMyPlaylistTracks = processMyPlaylistTracks;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nameMaxLength = exports.nameMaxLength = 30;

function processMyPlaylist(playlist) {
  var res = (0, _extends3.default)({}, playlist);
  res.projectId = res.guid;
  res.artist_name = res.name;
  res.list = (0, _uniq3.default)(res.list);
  res.tracksCount = (0, _get3.default)(res, 'list.length', 0);
  return res;
}

function processMyPlaylists(playlists) {
  return playlists.map(processMyPlaylist);
}

function processMyPlaylistTracks(playlist, albumTracks) {
  var tracksId = (0, _get3.default)(playlist, 'list', []);
  var res = [];
  tracksId.map(function (trackId) {
    if (albumTracks[trackId]) {
      res.push(albumTracks[trackId]);
    }
  });
  return res;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/my-playlists.js
// module id = 527
// module chunks = 1